import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4, 0),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // [theme.breakpoints.up('md')]: {
    //   padding: theme.spacing(4, 2),
    // },
  },
  description: {
    marginBottom: ({ regularBottom }) => !regularBottom && theme.spacing(4),
    lineHeight: theme.spacing(0.2),
    fontStyle: ({ italic }) => italic && 'italic',
    fontFamily: ({ italic }) => italic && 'Roboto Condensed',
    color: ({ light }) => light && theme.palette.text.white,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.body1.fontSize,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: ({ italic }) => italic && theme.typography.h4.fontSize,
    },
  },
}))
